import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from 'vuex-module-decorators'
import CookiesUtils from '@/common/utils/CookiesUtils'
import store from '@/store'

export enum DeviceType {
  Mobile,
  Desktop
}

export interface AppState {
  device: DeviceType
  sidebar: {
    opened: boolean
    withoutAnimation: boolean
  }
  useAreaHeight: number // 可以用区域高度
  topHeadHeight: number // 顶部菜单高度
  tagViewHeight: number // tab框高度
  searchFormHeight: number //  搜索框高度
  homeMenu: Array<any>
}

@Module({ dynamic: true, store, name: 'app' })
class App extends VuexModule implements AppState {
  public sidebar = {
    opened: CookiesUtils.getSidebarStatus() !== 'closed',
    withoutAnimation: false
  }
  public device = DeviceType.Desktop
  public useAreaHeight = 0
  public topHeadHeight = 50
  public tagViewHeight = 50
  public searchFormHeight = 0
  public homeMenu = CookiesUtils.getRoles()

  @Mutation
  private TOGGLE_SIDEBAR(withoutAnimation: boolean) {
    this.sidebar.opened = !this.sidebar.opened
    this.sidebar.withoutAnimation = withoutAnimation
    if (this.sidebar.opened) {
      CookiesUtils.setSidebarStatus('opened')
    } else {
      CookiesUtils.setSidebarStatus('closed')
    }
  }

  @Mutation
  private CLOSE_SIDEBAR(withoutAnimation: boolean) {
    this.sidebar.opened = false
    this.sidebar.withoutAnimation = withoutAnimation
    CookiesUtils.setSidebarStatus('closed')
  }

  @Mutation
  private SET_USEAREAHEIGHT(height: number) {
    this.useAreaHeight = height
  }
  @Mutation
  private SET_TOPHEADHEIGHT(height: number) {
    this.topHeadHeight = height
  }
  @Mutation
  private SET_TAGVIEWHEIGHT(height: number) {
    this.tagViewHeight = height
  }
  @Mutation
  private SET_SEARCHFORMHEIGHT(height: number) {
    this.searchFormHeight = height
  }

  @Mutation
  private TOGGLE_DEVICE(device: DeviceType) {
    this.device = device
  }

  @Mutation
  private SET_HOMEMENU(homeMenu: any) {
    this.homeMenu = homeMenu
  }

  @Action
  public ToggleSideBar(withoutAnimation: boolean) {
    this.TOGGLE_SIDEBAR(withoutAnimation)
  }

  @Action
  public CloseSideBar(withoutAnimation: boolean) {
    this.CLOSE_SIDEBAR(withoutAnimation)
  }

  @Action
  public ToggleDevice(device: DeviceType) {
    this.TOGGLE_DEVICE(device)
  }

  @Action
  public updateUseAreaHeight(height: number) {
    if (height) {
      this.SET_USEAREAHEIGHT(height)
    } else {
      // this.SET_USEAREAHEIGHT(0)
    }
  }

  @Action
  public updateTopHeadHeight(height: number) {
    if (height) {
      this.SET_TOPHEADHEIGHT(height)
    } else {
      // this.SET_TOPHEADHEIGHT(0)
    }
  }

  @Action
  public updateTagViewHeight(height: number) {
    if (height) {
      this.SET_TAGVIEWHEIGHT(height)
    } else {
      // this.SET_TAGVIEWHEIGHT(0)
    }
  }

  @Action
  public updateSearchFormHeight(height: number) {
    if (height) {
      this.SET_SEARCHFORMHEIGHT(height)
    } else {
      // this.SET_SEARCHFORMHEIGHT(0)
    }
  }

  @Action
  public printHeight() {
    // console.log(this.useAreaHeight, this.topHeadHeight, this.tagViewHeight, this.searchFormHeight)
  }

  @Action
  public updateHomeMenu(homeMenu: any) {
    if (homeMenu) {
      this.SET_HOMEMENU(homeMenu)
    }
  }
}

export const AppModule = getModule(App)
